import script from "./OrganizationManagement.vue?vue&type=script&setup=true&lang=js"
export * from "./OrganizationManagement.vue?vue&type=script&setup=true&lang=js"

import "./OrganizationManagement.vue?vue&type=style&index=0&id=2450486a&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2450486a"]])

export default __exports__